export default __webpack_public_path__ + "static/media/Goal_2.87bbcbd4.zip";